import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamation = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	"xmlns:v": "https://vecta.io/nano",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M8 0A8 8 0 0 0 .609 4.939a8 8 0 0 0 1.734 8.718 8 8 0 0 0 8.718 1.734A8 8 0 0 0 16 8a8.01 8.01 0 0 0-8-8zm0 14.667c-1.319 0-2.607-.391-3.704-1.124s-1.951-1.774-2.455-2.992-.637-2.559-.379-3.852.892-2.481 1.825-3.413 2.12-1.567 3.413-1.825 2.634-.125 3.852.379 2.259 1.359 2.992 2.455S14.667 6.681 14.667 8c-.002 1.768-.705 3.462-1.955 4.712S9.768 14.665 8 14.667zm-.917-9.67a.92.92 0 1 1 1.834 0l-.375 4.505C8.518 9.783 8.283 10 8 10s-.518-.217-.542-.498l-.375-4.505zM8 11a1 1 0 1 1 0 2 1 1 0 1 1 0-2z",
			fill: "#e69d15"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgExclamation;
